import { useQuery } from 'react-query';
import { getStudiesCompletedAndArchived } from '../../api/studiesAPI';

import Button from '../ui/Button';
import './CreateAmendmentByGin.scss';
import Loader from '../ui/Loader';

const CreateAmendmentByGin = ({
	onAddAmendmentFrom,
	onStartAmendmentFromStudy
}) => {
	const { isLoading, error, data, isError } = useQuery({
		queryKey: 'studiescompleted',
		queryFn: () => getStudiesCompletedAndArchived(),
		retry: false,
		staleTime: 3000000 //5 minutes to refetch
	});

	if (isLoading || !data) {
		return <Loader centered />;
	} else if (isError) {
		return <div>Error fetching post: {error.message}</div>;
	} else {
		const { studies } = data.data;
		const addAmendmentFrom = (id) => {
			onAddAmendmentFrom(id);
			onStartAmendmentFromStudy();
		};
		return (
			<div className='create-amendment-main-container'>
				<div className='create-amendment-table-labels'>
					<h4>Current Studies</h4>
					<p className='create-amendment-table-subtitle'>
						Please select one of the studies below to add a
						new amendment.
					</p>
				</div>
				<table className='table table-bordered create-amendment-table'>
					<thead className='table-secondary'>
						<tr>
							<th>Analysis Study Name</th>
							<th>Sponsor Name</th>
							<th>P.I. Name</th>
							<th>Version</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						{studies.map((s) => (
							<tr key={s._id}>
								<td>
									<div className='table-amendment-column'>
										{s.title}
									</div>
								</td>
								<td>{s.sponsor || ''}</td>
								<td>{s.pi?.firstname || ''}</td>
								<td>{s.version || ''}</td>
								<td>
									<Button
										className='primary-button'
										startIcon='add'
										onClick={() => addAmendmentFrom(s._id)}
									>
										Add
									</Button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}
};

export default CreateAmendmentByGin;
